import { types } from 'mobx-state-tree';

export const SyncData = types
  .model({
    syncDataStatus: types.maybeNull(types.boolean),
    workpackageSync: types.maybeNull(types.boolean),
    masterDataSync: types.maybeNull(types.boolean),
    inspectionFilesSync: types.maybeNull(types.boolean),
    deficiencyFilesSync: types.maybeNull(types.boolean),
    previousReportSync: types.maybeNull(types.boolean),
    workpackageFilesSync: types.maybeNull(types.boolean),
    fixTotalCount: types.number,
    totalDownloadCount: types.number,
    componentTypeListSync: types.maybeNull(types.boolean),
    remedialActionListSync: types.maybeNull(types.boolean),
    conditionRatingListSync: types.maybeNull(types.boolean),
    primaryCauseOfFailureListSync: types.maybeNull(types.boolean),
    urgencyListSync: types.maybeNull(types.boolean),
    operationalDowntimeListSync: types.maybeNull(types.boolean),
    trafficSafetyListSync: types.maybeNull(types.boolean),
    isSyncing: types.boolean,
  })
  .views(self => ({
    get getSyncStatus() {
      return self.syncDataStatus;
    },
  }))
  .actions(self => ({
    setSyncStatus: (status: boolean) => {
      self.syncDataStatus = status;
    },
    setWorpackageSync: (status: boolean) => {
      self.workpackageSync = status;
    },
    setMasterDataSync: (status: boolean) => {
      self.masterDataSync = status;
    },
    setInspectionFileSync: (status: boolean) => {
      self.inspectionFilesSync = status;
    },
    setDeficiencyFileSync: (status: boolean) => {
      self.deficiencyFilesSync = status;
    },
    setPreviousReportSync: (status: boolean) => {
      self.previousReportSync = status;
    },
    setWorkPackageFilesSync: (status: boolean) => {
      self.workpackageFilesSync = status;
    },
    setTotalFileCount: (totalCount: number) => {
      self.totalDownloadCount = totalCount;
    },
    setTotalFixCount: (totalCount: number) => {
      self.fixTotalCount = totalCount;
    },
    resetTotalCount: () => {
      self.totalDownloadCount = 0;
      self.fixTotalCount = 0;
    },
    setComponentTypeListSync: (status: boolean) => {
      self.componentTypeListSync = status;
    },
    setRemedialActionListSync: (status: boolean) => {
      self.remedialActionListSync = status;
    },
    setConditionRatingListSync: (status: boolean) => {
      self.conditionRatingListSync = status;
    },
    setPrimaryCauseOfFailureListSync: (status: boolean) => {
      self.primaryCauseOfFailureListSync = status;
    },
    setUrgencyListSync: (status: boolean) => {
      self.urgencyListSync = status;
    },
    setOperationalDowntimeListSync: (status: boolean) => {
      self.operationalDowntimeListSync = status;
    },
    setTrafficSafetyListSync: (status: boolean) => {
      self.trafficSafetyListSync = status;
    },
    setIsSyncing: (flag: boolean) => {
      self.isSyncing = flag;
    },
  }));

export default SyncData;
